import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const SelectInput = ({
  label,
  value,
  onChange,
  options = [],
  size = 'small',
  sx = {},
  labelId,
  ...props
}) => {
  const id = labelId || `${label.replace(/\s+/g, '-').toLowerCase()}-select`;

  return (
    <FormControl size={size} sx={{ minWidth: 120,...sx }}>
      {label && <InputLabel id={id} sx={{color:'background.text'}}>{label}</InputLabel>}
      <Select
        labelId={id}
        id={`${id}-input`}
        value={value}
        label={label}
        onChange={onChange}
        sx={{color:'background.text'}}
        {...props}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} sx={{color:'background.text'}}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectInput;
